export class ClientCriteria {
  clientId: number = null;
  legalName: string = null;
  dateOfBirth: Date = null;
  emailAddress: string = null;
  phoneNumber: string = null;
}
